import React from 'react'

export const PactoClaro = () => {
    return (
        <div>
        <div className="pacto_claro">
          <b>¿QUÉ ES PACTO CLARO?</b>
          <p>
          Es un documento formal con información sencilla, concisa y fácil de entender que se extiende a todos los clientes que inician una suscripción a un Plan de Ahorro. Cabe destacar que esta herramienta no reemplaza el contrato de suscripción original, sino que anticipa puntos de importancia a tener en cuenta.
          El mismo contiene: información sobre el vehículo a adquirir, datos útiles sobre las cuotas, tiempos de entrega e información en general que FIAT PLAN pretende que quede bien en claro antes de iniciar la experiencia de un Plan de Ahorro.
          Es importante señalar que Pacto Claro incluye, más allá de los datos del asesor comercial, los datos del área administrativa del concesionario con el correspondiente asesor de cuenta.
          </p>
        </div>
        <div className="pacto_claro">
          <b>¿CÓMO FUNCIONA PACTO CLARO?</b>
          <p>
          El cliente que está iniciando el proceso de suscripción recibirá en su cuenta personal de correo electrónico, un e-mail enviado mediante respaldo notarial, que llevará un Link de acceso a su “Pacto Claro”.
Haciendo click en el link, el cliente accederá a su PACTO CLARO
          </p>
        </div>

        <div className="pacto_claro_img">
          <img src="/images/background/pacto_claro_flyer.jpg" />
        </div>


        <div className="pacto_claro texto_centrado">
          <span>
            ¡NO TE OLVIDES DE PEDIR TU PACTO CLARO!
          </span>
        </div>
        </div>
    )
}
